import { styled } from "../../../stitches.config";
import { Box, FlexBox } from "../../primitives";

export const ContainerStyled = styled(Box, {
  padding: "0px 20px 0 20px",
  width: "250px",
  borderRadius: "8px",
  fontFamily: "Arial, sans-serif",
  fontSize: "14px",
  "@smRev": {
    width: "100%",
  },
});

export const FieldStyled = styled(FlexBox, {
  flexDirection: "column",
  marginBottom: "16px",
  flexGrow: 1,
});
